export default __webpack_public_path__ + "static/media/element_51.d8636e73.webp";